import { hasObjectFitCover } from '~/utils/compability';

export default {
  props: {
    src: String,
  },
  data() {
    return {
      hasObjectFitCover,
    };
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/image-helper/ImageHelper.js